import React from 'react';

import {convertParamsForVersionsQuery} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/utils';
import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {useInfiniteListFetcherRTK} from 'app/general/datafetchers/hooks/useInfiniteListFetcherRTK';
import {usePolicyVersions} from 'app/policies/api';

import type {LeftSidebarPanelType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  DetailPolicySerializedType,
  ListPolicyVersionSerializedType,
} from 'sweet-types';

const VersionsSidebarComponent =
  VersionsSidebarFactory<ListPolicyVersionSerializedType>();
export function PolicyVersionsPanelContent({
  object,
  version,
}: LeftSidebarPanelType<DetailPolicySerializedType>) {
  const {
    results: versions,
    refetch,
    loadNext,
    hasNext,
  } = useInfiniteListFetcherRTK({
    fetchParams: {
      objectId: object.id,
    },
    useDataHook: usePolicyVersions,
    paramsConverter: convertParamsForVersionsQuery,
  });
  return (
    <VersionsSidebarComponent
      object={object}
      selectedVersion={version}
      loadVersions={async () => refetch()}
      loadMoreVersions={async () => loadNext()}
      moreToLoad={hasNext}
      versions={versions}
    />
  );
}
